import React from "react";
import JPlayer, { connect, Gui, SeekBar, BufferBar,
  Poster, Audio, Title, FullScreen, Mute, Play, PlayBar, Repeat,
  VolumeBar, Duration, CurrentTime, Download, BrowserUnsupported,
 } from 'react-jplayer';
import Footer from "../../components/Footer";
import { Provider } from 'react-redux';
import { initialState as jPlayerInitialState, reducer as jPlayers } from 'react-jplayer';
import { initialState as jPlaylistInitialState, reducer as jPlaylists } from 'react-jplaylist';
import { createStore, combineReducers } from 'redux';
// Styles the jPlayer to look nice
import 'react-jplaylist/src/less/skins/sleek.less';
// Styles Play/Pause/Mute etc when icons (<i />) are used for them
import 'react-jplaylist/src/less/controls/iconControls.less';
import AudioPlaylist from '../../components/AudioPlaylist';
import MarvinsRoomremix from "../assets/MarvinsRoomremix.mp3";
import makeitoutremix from "../assets/makeitoutremix.mp3";
import CollegeLife from "../assets/CollegeLife.mp3";
import LookinAtMe from "../assets/LookinAtMe.mp3";
import SoFar from "../assets/SoFar.mp3";
import $ from "jquery";
import Coverart from "../assets/Coverart.jpg";
	
const store = createStore(combineReducers({
  jPlayers,
  jPlaylists,
}), {
  jPlayers: jPlayerInitialState(AudioPlaylist),
  jPlaylists: jPlaylistInitialState(AudioPlaylist),
});
export default class Music extends React.Component {
	componentDidMount = () =>{
    	$("body").css("display", "none");
 
    	$("body").fadeIn(1000);
	}
	render() {
		return(
			<div className="Music">
				<h1>The Music</h1>
				<h5>Enjoy</h5>
				<Provider store={store}>
    				<AudioPlaylist />
  				</Provider>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/protected/Music.js